/* ================================================== */
/* PLUGINS > Fluid elements
/* ================================================== */

$(function() {
	var $fluidElements = $('.wrapper--video, .wrapper--embed, .body__code'),
		sources        = 'iframe[src^="http://player.vimeo.com"], iframe[src^="http://www.youtube.com"], object, embed, iframe';

	$fluidElements.each(function(){
		$(this).find(sources).each(function(index, element){
			$(element).attr('data-aspect-ratio', this.height / this.width).removeAttr('height').removeAttr('width');
		});
	});

	function setFluidElementsDimensions() {
		$fluidElements.each(function() {
			var newWidth = $(this).width();
			$(this).find(sources).each(function(index, element){
				$(element).width(newWidth).height(newWidth * $(element).attr('data-aspect-ratio'));
			});
		});
	}

	$(document).ready(setFluidElementsDimensions());
	$(window).on('resize orientationchange', function() {
		setFluidElementsDimensions();
	});
});